// this wrapper around withRouter from nextJS is needed to fix the issue with the header link component from monolu, if now rewrite is used to redirect index pages to home file. The header links component expects the home page to end with home, this wrapper will add home to the route if is home page

import { type NextRouter, withRouter as withNextRouter } from 'next/router';
import { useEffect, useState } from 'react';

interface Props {
  router: NextRouter;
  [key: string]: unknown;
}

const langs = ['/fr', '/de', '/nl', '/uk'];
const carAliases = ['/fsd'];

const getModifiedRouter = (router: NextRouter): NextRouter => {
  if (langs.some(lang => router.pathname.includes(lang))) {
    return {
      ...router,
      route: `/${router.route.split('/').at(-1)}`, // to highlight the active link
      pathname: `/${router.pathname.split('/').at(-1)}`, // to get the currentPage in monolu
    };
  }

  if (carAliases.some(alias => router.pathname === alias || router.route === alias)) {
    return {
      ...router,
      route: '/car',
      pathname: '/car',
    };
  }

  return router;
};

export const withCustomRouter = <P extends object>(Component: React.FC<P & Props>) => {
  return withNextRouter(({ router, ...props }: Props & P) => {
    const [stateRouter, setStateRouter] = useState(() => getModifiedRouter(router));

    useEffect(() => {
      setStateRouter(getModifiedRouter(router));
    }, [router]);

    return <Component {...(props as P)} router={stateRouter} />;
  });
};
